// @ts-check
// Paginação por coluna do kanban: cada coluna carrega 30 cartões e pede os seguintes pelo cursor da própria coluna
// (rolagem até o fim ou botão "Carregar mais"), para nenhum lead além do 30º sumir do funil. A contagem do cabeçalho
// continua vindo do groupBy, que conta a coluna inteira.

export const CARDS_PER_COLUMN = 30;

/**
 * @typedef {{ hasNextPage: boolean, endCursor: string | null, isLoadingMore: boolean }} ColumnPageState
 * @typedef {(options: { filter: any, orderBy: any, limit: number, startingAfter?: string, depth: number, drilldown?: string | null }) =>
 *   Promise<{ records: any[], pageInfo: { hasNextPage?: boolean, endCursor?: string | null } }>} FindColumnPage
 */

/**
 * Estado da coluna depois de uma página recebida.
 * @param {{ records: any[], pageInfo: { hasNextPage?: boolean, endCursor?: string | null } }} result
 * @returns {ColumnPageState}
 */
export function toColumnPageState(result) {
  const endCursor = result.pageInfo?.endCursor ?? null;
  return { hasNextPage: Boolean(result.pageInfo?.hasNextPage) && Boolean(endCursor) && result.records.length > 0, endCursor, isLoadingMore: false };
}

/**
 * Próxima página de uma coluna, a partir do cursor guardado.
 * @param {FindColumnPage} findPage @param {{ filter: any, orderBy: any, drilldown?: string | null }} query @param {ColumnPageState | undefined} state
 *   drilldown: lista aberta por um clique num gráfico, que segue em cada página
 */
export async function loadNextColumnPage(findPage, query, state) {
  if (!state?.hasNextPage || !state.endCursor) return { records: [], state: state ?? { hasNextPage: false, endCursor: null, isLoadingMore: false } };
  const result = await findPage({
    filter: query.filter, orderBy: query.orderBy, limit: CARDS_PER_COLUMN, startingAfter: state.endCursor, depth: 1, ...(query.drilldown ? { drilldown: query.drilldown } : {}),
  });
  return { records: result.records, state: toColumnPageState(result) };
}

/**
 * Junta os cartões novos aos já carregados sem repetir (um cartão movido entre colunas pode voltar numa página).
 * @param {any[]} current @param {any[]} incoming
 */
export function appendUniqueRecords(current, incoming) {
  const knownIds = new Set(current.map((record) => record.id));
  return [...current, ...incoming.filter((record) => !knownIds.has(record.id))];
}
